var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", xl: "6" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("ubl-settings")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-select", {
                            attrs: {
                              items: _vm.ublTypes,
                              label: _vm.$ct("ubl-type"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.config.UblType,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "UblType", $$v)
                              },
                              expression: "config.UblType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-input", {
                            attrs: { label: _vm.$ct("cost-center"), fancy: "" },
                            model: {
                              value: _vm.config.CostCenter,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "CostCenter", $$v)
                              },
                              expression: "config.CostCenter",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("app-payment-means-code-select", {
                            attrs: {
                              label: _vm.$ct("ubl-default-payment-means-code"),
                              "empty-text": _vm.$ct(
                                "ubl-default-payment-means-code-standard"
                              ),
                            },
                            model: {
                              value: _vm.config.DefaultPaymentMeansCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config,
                                  "DefaultPaymentMeansCode",
                                  $$v
                                )
                              },
                              expression: "config.DefaultPaymentMeansCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("app-ledger-account-autocomplete", {
                            attrs: {
                              label: _vm.$ct("ledger-leeggoed"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.config.LeeggoedLedger,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "LeeggoedLedger", $$v)
                              },
                              expression: "config.LeeggoedLedger",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: { label: _vm.$ct("include-sale-in-ubl") },
                            model: {
                              value: _vm.config.IncludeSalePdf,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "IncludeSalePdf", $$v)
                              },
                              expression: "config.IncludeSalePdf",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("include-sale-seperatly-in-zip"),
                            },
                            model: {
                              value: _vm.config.IncludeSaleSeperatelyInZip,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config,
                                  "IncludeSaleSeperatelyInZip",
                                  $$v
                                )
                              },
                              expression: "config.IncludeSaleSeperatelyInZip",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("app-include-pdfs-in-archive-mode-select", {
                            attrs: {
                              label: _vm.$ct("include-purchase-pdfs-in-xml"),
                            },
                            model: {
                              value: _vm.config.IncludePurchasePdfsInXml,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config,
                                  "IncludePurchasePdfsInXml",
                                  $$v
                                )
                              },
                              expression: "config.IncludePurchasePdfsInXml",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("app-include-pdfs-in-archive-mode-select", {
                            attrs: {
                              label: _vm.$ct("include-purchase-pdfs-in-zip"),
                            },
                            model: {
                              value: _vm.config.IncludePurchasePdfsInZip,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config,
                                  "IncludePurchasePdfsInZip",
                                  $$v
                                )
                              },
                              expression: "config.IncludePurchasePdfsInZip",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct(
                                "use-ledger-account-as-invoice-line-name"
                              ),
                            },
                            model: {
                              value:
                                _vm.config.UseLedgerAccountAsInvoiceLineName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config,
                                  "UseLedgerAccountAsInvoiceLineName",
                                  $$v
                                )
                              },
                              expression:
                                "config.UseLedgerAccountAsInvoiceLineName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("filter-purchases-on-vat-period"),
                            },
                            model: {
                              value: _vm.config.FilterPurchasesOnVatPeriod,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config,
                                  "FilterPurchasesOnVatPeriod",
                                  $$v
                                )
                              },
                              expression: "config.FilterPurchasesOnVatPeriod",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("clear-facts-compatibility"),
                            },
                            model: {
                              value: _vm.config.ClearFactsCompatibiltiy,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config,
                                  "ClearFactsCompatibiltiy",
                                  $$v
                                )
                              },
                              expression: "config.ClearFactsCompatibiltiy",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: { label: _vm.$ct("include-client-xml") },
                            model: {
                              value: _vm.config.IncludeClientsXml,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "IncludeClientsXml", $$v)
                              },
                              expression: "config.IncludeClientsXml",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("normalize-peppol-ubl-prefixes"),
                            },
                            model: {
                              value: _vm.config.NormalizePeppolUblPrefixes,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config,
                                  "NormalizePeppolUblPrefixes",
                                  $$v
                                )
                              },
                              expression: "config.NormalizePeppolUblPrefixes",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c("w-spacer"),
                  _vm.$wf.isMdUp
                    ? _c(
                        "w-button",
                        {
                          attrs: { icon: "save" },
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }